import { TextInputFormikPropTypes, TextInputFormikDefaultProps } from '../../Utils/TextInputPropTypes';

export const InputZipCodePropTypes = TextInputFormikPropTypes;
export const InputZipCodeDefaultProps = TextInputFormikDefaultProps;

export default { InputZipCodePropTypes, InputZipCodeDefaultProps };
